import { z } from "zod"

export const organizationBillingDetailsSchema = z.object({
  billingAddress: z
    .string()
    .max(255, "Billing address must be 255 characters or less")
    .nullable(),
  billingCity: z
    .string()
    .max(255, "Billing city must be 255 characters or less")
    .nullable(),
  billingState: z
    .string()
    .max(255, "Billing state must be 255 characters or less")
    .nullable(),
  billingZipCode: z
    .string()
    .max(20, "Billing zip code must be 20 characters or less")
    .nullable(),
  billingCountry: z
    .string()
    .max(255, "Billing country must be 255 characters or less")
    .nullable(),
  billingContactName: z
    .string()
    .max(255, "Billing contact name must be 255 characters or less")
    .nullable(),
  billingContactEmail: z
    .string()
    .email("Invalid email format")
    .or(z.literal(""))
    .nullable(),
})

export type OrganizationBillingDetailsFormData = z.infer<
  typeof organizationBillingDetailsSchema
>
